import { getFilteredElements, hydrateFilters } from 'src/utils/FilterUtils';

import { createCareModelCohortSuggestion } from '../../application/useCases/createCareModelCohortSuggestion';
import { useCohortsFiltersColumns } from './useCohortsFiltersColumns';

/** @typedef {
 *   import('../../domain/entities/CareModelCohort.types').CareModelCohort
 * } CareModelCohort */
/** @typedef {
 *   import('../../domain/entities/CareModelCohort.types').Client
 * } Client */
/** @typedef {
 *   import('../../domain/entities/CareModelCohortAssignment.types').CareModelCohortMatch
 * } CareModelCohortMatch */

// eslint-disable-next-line import/prefer-default-export
export function useCareModelCohortSuggestion() {
  const { columns } = useCohortsFiltersColumns();

  const suggestionUseCase = createCareModelCohortSuggestion(
    hydrateFilters,
    getFilteredElements,
  );

  /**
   * @param {{ client: Client, cohorts: CareModelCohort[] }} params
   * @returns {CareModelCohortMatch | null}
   */
  function getSuggestedCohortForClient({ client, cohorts = [] }) {
    return suggestionUseCase.getSuggestedCohortForClient({
      client,
      cohorts,
      columns: columns.value,
    });
  }

  return {
    getSuggestedCohortForClient,
  };
}
